import "./site-header-controller";



// WEBPACK FOOTER //
// ./project/client/src/core/components/site-header/index.js